import type { FoerderRegime } from "../../../../types/api.types";
import { getNeedsGebotstermin } from "../../../../utils/getNeedsGebotstermin";
import { getNeedsJahrDesGebotstermins } from "../../../../utils/getNeedsJahrDesGebotstermins";
import type { ExpressOnboardingGenerator } from "../../ExpressOnboarding.types";

/**
 * Which data ("Fehlende Daten") is still missing for any of the given generators of a site.
 */
function getSiteMissingData(siteGenerators: Array<ExpressOnboardingGenerator>) {
  const isMissingGeneralData = siteGenerators.some(
    (generator) =>
      !generator.sr_id ||
      !generator.tr_id ||
      typeof generator.location_id !== "number" ||
      typeof generator.generation_share !== "number"
  );

  const isMissingEegAnlageData = siteGenerators.some(
    (generator) =>
      !generator.eeg_inbetriebnahme ||
      !generator.foerderregime ||
      (!!generator.foerderregime &&
        getNeedsJahrDesGebotstermins(
          generator.foerderregime as FoerderRegime
        ) &&
        typeof generator.jahr_des_gebotstermins !== "number") ||
      (!!generator.jahr_des_gebotstermins &&
        getNeedsGebotstermin(generator.jahr_des_gebotstermins) &&
        !generator.gebotstermin) ||
      typeof generator.anzulegender_wert !== "number" ||
      !generator.veraeusserungsform
  );

  const isSiteMissingData = isMissingGeneralData || isMissingEegAnlageData;

  return { isMissingGeneralData, isMissingEegAnlageData, isSiteMissingData };
}

export { getSiteMissingData };
